import * as React from 'react';
import { ErrorNotification, SuccessNotification } from '@verclam/toast-v2';

/** `eventName` matches the `type` of the actions dispatched by `Application/Users/**`. */
const UsersNotifications: React.FC = () => {
	return (
		<React.Fragment>
			<SuccessNotification
				eventName="USER_INVITED"
				title="Invitation envoyée"
				message="L'invitation a bien été envoyée."
			/>
			<SuccessNotification
				eventName="USER_UPDATED"
				title="Utilisateur modifié"
				message="L'utilisateur a bien été modifié."
			/>
			<SuccessNotification
				eventName="INVITATION_RESENT"
				title="Invitation renvoyée"
				message="L'invitation a bien été renvoyée."
			/>
			<SuccessNotification
				eventName="INVITATION_REVOKED"
				title="Invitation annulée"
				message="L'invitation a bien été annulée."
			/>
			<SuccessNotification
				eventName="PASSWORD_RESET_REQUESTED"
				title="Lien envoyé"
				message="Le lien de réinitialisation a bien été envoyé."
			/>
			<SuccessNotification
				eventName="USER_ACTIVATED"
				title="Compte réactivé"
				message="Le compte a bien été réactivé."
			/>
			<SuccessNotification
				eventName="USER_DEACTIVATED"
				title="Compte désactivé"
				message="Le compte a bien été désactivé."
			/>
			<SuccessNotification
				eventName="USER_MFA_RESET"
				title="Second facteur réinitialisé"
				message="Le second facteur a bien été réinitialisé."
			/>
			<SuccessNotification
				eventName="USER_DELETED"
				title="Invitation supprimée"
				message="L'invitation a bien été supprimée."
			/>
			<ErrorNotification
				eventName="USERS_FETCH_FAILED"
				title="Erreur"
				message="La liste des utilisateurs n'a pas pu être chargée."
			/>
			<ErrorNotification
				eventName="USER_INVITATION_FAILED"
				title="Erreur"
				message="L'invitation n'a pas pu être envoyée."
			/>
			<ErrorNotification
				eventName="USER_UPDATE_FAILED"
				title="Erreur"
				message="L'utilisateur n'a pas pu être modifié."
			/>
			<ErrorNotification
				eventName="INVITATION_RESEND_FAILED"
				title="Erreur"
				message="L'invitation n'a pas pu être renvoyée."
			/>
			<ErrorNotification
				eventName="INVITATION_REVOCATION_FAILED"
				title="Erreur"
				message="L'invitation n'a pas pu être annulée."
			/>
			<ErrorNotification
				eventName="PASSWORD_RESET_REQUEST_FAILED"
				title="Erreur"
				message="Le lien de réinitialisation n'a pas pu être envoyé."
			/>
			<ErrorNotification
				eventName="USER_ACTIVATION_FAILED"
				title="Erreur"
				message="Le compte n'a pas pu être réactivé."
			/>
			<ErrorNotification
				eventName="USER_DEACTIVATION_FAILED"
				title="Erreur"
				message="Le compte n'a pas pu être désactivé."
			/>
			<ErrorNotification
				eventName="USER_DELETION_FAILED"
				title="Erreur"
				message="L'invitation n'a pas pu être supprimée."
			/>
			<ErrorNotification
				eventName="USER_MFA_RESET_FAILED"
				title="Erreur"
				message="Le second facteur n'a pas pu être réinitialisé."
			/>
		</React.Fragment>
	);
};

export default UsersNotifications;
